import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-appointment-type-edit-modal',
  templateUrl: './appointment-type-edit-modal.component.html',
  styleUrls: ['./appointment-type-edit-modal.component.css']
})
export class AppointmentTypeEditModalComponent implements OnInit {
  @Input() appointmentType: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSave = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onSaveAppointmentType(evt: any) {
    this.onSave.emit(evt);
  }

  closeModal() {
    this.onCloseModal.emit();
  }
}
